import Tooltip from '@mui/material/Tooltip'
import { isNil } from 'lodash'

import {
  resolveDirection,
  resolveValueColor,
} from '#/components/FormatCell/Types/Variation/Logic/colors'
import { TypeVariationProps } from '#/components/FormatCell/Types/Variation/types'
import { Segment, Wrapper } from '#/components/FormatCell/Types/Variation/View/Styled'
import { DeteriorateIcon, ImproveIcon } from '#/components/Icon/Collection'

const directionIcons = {
  down: DeteriorateIcon,
  up: ImproveIcon,
} as const

const TypeVariation = ({
  bold = true,
  hideIf,
  icon,
  level,
  reverse,
  slotProps,
  tooltip,
  value,
}: TypeVariationProps) => {
  if (hideIf) {
    return null
  }

  if (isNil(value)) {
    return '-'
  }

  const direction = icon ? resolveDirection(value, reverse) : null
  const DirectionIcon = direction ? directionIcons[direction] : null
  const color = resolveValueColor({ level, reverse, value })

  const content = (
    <Wrapper sx={slotProps?.root?.sx}>
      {DirectionIcon && <DirectionIcon color={color} fontSize={14} sx={slotProps?.icon?.sx} />}
      <Segment bold={bold} textColor={color} sx={slotProps?.value?.sx}>
        {value}
      </Segment>
    </Wrapper>
  )

  return isNil(tooltip) ? content : <Tooltip title={tooltip}>{content}</Tooltip>
}

export default TypeVariation
